"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupsObject = void 0;
const groups_js_1 = require("./groups.js");
/**
 * The groups indexed by their symbol. Symbols are unique, which is asserted by
 * the tests of this package and by the groups editor.
 */
exports.groupsObject = {};
for (const group of groups_js_1.groups) {
    exports.groupsObject[group.symbol] = group;
}
//# sourceMappingURL=groupsObject.js.map